import Vue from 'vue';

const formatNumber = (value) => {
  return `${value}`.replace(/(\d)()(?=(\d\d\d)+(\D|$))/g, '$1\u00A0$2');
};

Vue.filter('formatNumber', (value) => {
  if (value) {
    return formatNumber(value);
  }
  return '';
});
